var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.env != 'zfb')?_c('div',{staticClass:"img_account"},[_c('img',{attrs:{"src":require("@/assets/image/account_code.jpg"),"alt":""}}),_c('div',{staticClass:"mt_2"},[_vm._v("长按识别二维码关注公众号，查询下载保单")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }